import {
  ChatAccessIcon,
  ChatIcon,
  DashboardIcon,
  FundManagementIcon,
  IconAppointment,
  ReviewsIcon,
  SubscriptionIcon,
  TicketManagementIcon,
} from "../../../../assets/svg";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../constants/routeConsts";
import { userRoles } from "../../../../constants";
import { useTranslation } from "react-i18next";

export const useStaffSidebarUtils = (userSession) => {
  const { t } = useTranslation();

  let menuGroup = [];

  const role = userSession?.userRole;
  const permissionsObj = userSession?.permissions?.find(
    (item) => item?.role === role
  );

  const isAppointmentActive = permissionsObj?.permissions?.find(
    (item) => item?.code === "APPOINTMENTS"
  );
  const isChatActive = permissionsObj?.permissions?.find(
    (item) => item?.code === "CHAT"
  );

  const isFundActive = permissionsObj?.permissions?.find(
    (item) => item?.code === "FUND_MANAGEMENT"
  );
  const isSubscriptionActive = permissionsObj?.permissions?.find(
    (item) => item?.code === "SUBSCRIPTIONS"
  );

  const isTicketActive = permissionsObj?.permissions?.find(
    (item) => item?.code === "TICKET_MANAGEMENT"
  );

  const isChatAccessActive = permissionsObj?.permissions?.find(
    (item) => item?.code === "CHAT_ACCESS"
  );

  /* menuItemDashboard */
  const menuItemDashboard = {
    label: t("AppModuleNames.Provider.Dashboard"),
    icon: DashboardIcon,
    path: baseRouteMaker(routes.STAFF_DASHBOARD),
  };
  if (!["accountant", "customer-support"].includes(role)) {
    menuGroup.push(menuItemDashboard);
  }

  /* menuItemDashboard */

  /* menuItemAppointment */
  const menuItemAppointment = {
    label: t("AppModuleNames.Provider.Appointments"),
    icon: IconAppointment,
    path: baseRouteMaker(routes.APPOINTMENT),
  };
  if (isAppointmentActive?.is_active) {
    menuGroup.push(menuItemAppointment);
  }
  /* menuItemAppointment */

  /* menuItemChat */
  const menuItemChat = {
    label: t("AppModuleNames.Provider.Chat"),
    icon: ChatIcon,
    path: baseRouteMaker(routes.CHAT),
  };
  if (isChatActive?.is_active) {
    menuGroup.push(menuItemChat);
  }
  /* menuItemChat */

  /* menuItemFundManagement */
  const menuItemFundManagement = {
    label: t("AppModuleNames.SuperAdmin.FundManagement"),
    icon: FundManagementIcon,
    path: baseRouteMakerForSuperAdmin(routes.FUND_MANAGEMENT),
  };
  if (isFundActive?.is_active) {
    menuGroup.push(menuItemFundManagement);
  }
  /* menuItemFundManagement */

  /* menuItemTicketManagement */
  const menuItemTicketManagement = {
    label: t("AppModuleNames.SuperAdmin.TicketManagement"),
    icon: TicketManagementIcon,
    path: baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT),
  };

  if (isTicketActive?.is_active) {
    menuGroup.push(menuItemTicketManagement);
  }

  /* menuItemTicketManagement */

  /* menuItemSubscription */
  const menuItemSubscription = {
    label: t("AppModuleNames.SuperAdmin.Subscription"),
    icon: SubscriptionIcon,
    path: baseRouteMakerForSuperAdmin(routes.SUBSCRIPTIONS),
  };
  if (isSubscriptionActive?.is_active) {
    menuGroup.push(menuItemSubscription);
  }

  /* menuItemSubscription */

  /* menuItemChatAccess */
  const menuItemChatAccess = {
    label: t("AppModuleNames.SuperAdmin.ChatAccess"),
    icon: ChatAccessIcon,
    path: baseRouteMakerForSuperAdmin(routes.CHAT_ACCESS),
  };
  if (isChatAccessActive?.is_active) {
    menuGroup.push(menuItemChatAccess);
  }
  /* menuItemChatAccess */

  /* menuItemReviews */
  const menuItemReviews = {
    label: t("AppModuleNames.SuperAdmin.Reviews"),
    icon: ReviewsIcon,
    path: baseRouteMaker(routes.SERVICE_PROVIDER_REVIEWS),
  };
  [
    userRoles.SERVICE_PROVIDER_ADMIN,
    userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR,
    userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF,
    userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF,
  ].includes(role) && menuGroup.push(menuItemReviews);
  /* menuItemReviews */

  return menuGroup;
};
